import { COLUMN, KIND } from "./constants"

// The value is suffixed with underscore, other wise javascript orders the props by there numerical value - which is not what we want
const asString = value => `${value}_`

const COLUMNS = {
  PORTRAIT: {
    [KIND.LSE.ROLES.COMMITTEES]: {
      [COLUMN.AGE]: true,
      [COLUMN.SEX]: true,
      [COLUMN.TENURE]: true,
    },
    [KIND.LSE.ROLES.BOARD]: {},
    [KIND.NEXUS.PERSON.COMMITTEES]: {
      [asString(COLUMN.STAR)]: true,
      [asString(COLUMN.COMPANY)]: true,
      [asString(COLUMN.COMMITTEE.AUDIT.CHAIRS)]: true,
      [asString(COLUMN.COMMITTEE.REMUNERATION.CHAIRS)]: true,
      [asString(COLUMN.COMMITTEE.NOMINATION.CHAIRS)]: true,
    },
    [KIND.NEXUS.COMPANY.COMMITTEES]: {
      [asString(COLUMN.STAR)]: true,
      [asString(COLUMN.OFFICER)]: true,
      [asString(COLUMN.COMMITTEE.AUDIT.CHAIRS)]: true,
      [asString(COLUMN.COMMITTEE.REMUNERATION.CHAIRS)]: true,
      [asString(COLUMN.COMMITTEE.NOMINATION.CHAIRS)]: true,
    },
  },
  LANDSCAPE: {
    [KIND.LSE.ROLES.COMMITTEES]: {
      [COLUMN.AGE]: true,
      [COLUMN.SEX]: true,
      [COLUMN.TENURE]: true,
    },
    [KIND.LSE.ROLES.BOARD]: {},
    [KIND.NEXUS.PERSON.COMMITTEES]: {
      [asString(COLUMN.STAR)]: true,
      [asString(COLUMN.COMPANY)]: true,
      [asString(COLUMN.ROLE)]: true,
      [asString(COLUMN.TENURE)]: true,
      [asString(COLUMN.COMMITTEE.AUDIT.CHAIRS)]: true,
      [asString(COLUMN.COMMITTEE.AUDIT.MEMBER)]: true,
      [asString(COLUMN.COMMITTEE.REMUNERATION.CHAIRS)]: true,
      [asString(COLUMN.COMMITTEE.REMUNERATION.MEMBER)]: true,
      [asString(COLUMN.COMMITTEE.NOMINATION.CHAIRS)]: true,
      [asString(COLUMN.COMMITTEE.NOMINATION.MEMBER)]: true,
    },
    [KIND.NEXUS.COMPANY.COMMITTEES]: {
      [asString(COLUMN.STAR)]: true,
      [asString(COLUMN.OFFICER)]: true,
      [asString(COLUMN.ROLE)]: true,
      [asString(COLUMN.TENURE)]: true,
      [asString(COLUMN.COMMITTEE.AUDIT.CHAIRS)]: true,
      [asString(COLUMN.COMMITTEE.AUDIT.MEMBER)]: true,
      [asString(COLUMN.COMMITTEE.REMUNERATION.CHAIRS)]: true,
      [asString(COLUMN.COMMITTEE.REMUNERATION.MEMBER)]: true,
      [asString(COLUMN.COMMITTEE.NOMINATION.CHAIRS)]: true,
      [asString(COLUMN.COMMITTEE.NOMINATION.MEMBER)]: true,
    },
  },
}

export default COLUMNS